import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ColumnReference } from 'app/model/dataset/columnReference';
import { DataFlowColumn } from 'app/model/dataset/dataflowcolumn';
import { IDataFlowDataType } from './dataflow-datatype';
import { IMapColumn } from './IMapColumn';
import { IdGenerationUtils } from './id-generation-utilities';

@Metamodel.model({
    name: 'dataFlowMapColumn'
})
export class DataFlowMapColumn extends DataFlowColumn implements IMapColumn {
    public static readonly MODEL: IModel;

    public columnRef: ColumnReference;

    /**
     * Property for renaming purpose.
     */
    public outputAlias?: string;

    /**
     * Property for type of the output.
     */
    public outputType?: IDataFlowDataType;

    /**
     * Whether the column needs to be written or not.
     */
    public writeColumn?: boolean;
    public rowIndex: number;

    private _displayId = IdGenerationUtils.generateUniqueId();
    public get displayIdentifier(): number {
        return this._displayId;
    }

    public static createFromColumnRef(columnRef: ColumnReference, writeColumn: boolean): DataFlowMapColumn {
        const newColumn: DataFlowMapColumn = new DataFlowMapColumn();
        newColumn.columnRef = columnRef;
        newColumn.outputAlias = columnRef.column.name;
        newColumn.name = columnRef.column.serializableColumnName;
        newColumn.writeColumn = writeColumn;
        return newColumn;
    }
}
